export type MessengerKind = 'viber' | 'telegram' | 'whatsapp';

export interface MessengerShareOptions {
    /** Preferred link part for Telegram share API (`url` query). */
    link?: string;
}

/** text + newline + link (skips empty parts). */
export const buildShareMessage = (text?: string, link?: string): string => {
    const parts = [String(text || '').trim(), String(link || '').trim()].filter(Boolean);
    return parts.join('\n');
};

/** Dialog default: empty first line, then text + link. */
export const buildDialogDefaultMessage = (text?: string, link?: string): string => {
    const body = buildShareMessage(text, link);
    return body ? `\n${body}` : '\n';
};

/** Share URL that opens the messenger so the user can pick a contact. */
export const buildMessengerShareUrl = (
    kind: MessengerKind,
    message: string,
    options?: MessengerShareOptions,
): string => {
    const encodedMessage = encodeURIComponent(message || '');
    const link = String(options?.link || '').trim();

    switch (kind) {
        case 'whatsapp':
            return `https://wa.me/?text=${encodedMessage}`;
        case 'viber':
            return `viber://forward?text=${encodedMessage}`;
        case 'telegram': {
            const shareUrl = encodeURIComponent(link || message || ' ');
            const shareText = link
                ? encodeURIComponent(String(message || '').replace(link, '').trim())
                : '';
            return shareText
                ? `https://t.me/share/url?url=${shareUrl}&text=${shareText}`
                : `https://t.me/share/url?url=${shareUrl}`;
        }
        default:
            return `https://wa.me/?text=${encodedMessage}`;
    }
};
